import type { CounterSize } from './types';

export const COUNTER_ROW_HEIGHT_PX: Record<CounterSize, number> = {
    small: 30,
    medium: 40,
    large: 48,
};

export type CounterRowDensity = 'compact' | 'default' | 'primary';
